import { Stack } from '@asgard/ui-library';
import Page from 'components/layout/Page';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { createGlobalStyle } from 'styled-components';
import { APP_URLS } from 'utils/app-urls';
import { getPublicPath } from 'utils/paths';
import { CompaniesPageProps } from './CompaniesPage.types';
import { CompaniesHero } from './hero/CompaniesHero';

import dynamic from 'next/dynamic';

const BottomBar = dynamic(() => import('./components/bottomBar/BottomBar'), {
  ssr: false
});

const CompaniesForm = dynamic(() => import('./form/CompaniesForm'), {
  ssr: false
});

const CompaniesFeatures = dynamic(
  () => import('./features/CompaniesFeatures'),
  {
    ssr: false
  }
);

export const CompaniesPage: React.FC<CompaniesPageProps> = ({
  bannerText,
  testimonials
}) => {
  const { t } = useI18n('companies-new');

  const CompaniesPageGlobalStyles = createGlobalStyle`
      #freshworks-container iframe {
        bottom: 90px !important;
      }
    `;

  return (
    <>
      <CompaniesPageGlobalStyles />
      <HeadMetadata
        title={t('companies-new.page_title')}
        desc={t('companies-new.page_description')}
        url={APP_URLS.companies}
        imgUrl={`${getPublicPath('/images/cards/card_companies_new.png')}`}
        indexable={true}
      />
      <Page hasScrollTop pageVariant="midnight_light" bannerText={bannerText}>
        <Stack direction="column" gap="5xl">
          <CompaniesHero />
          <CompaniesFeatures testimonials={testimonials} />
          <CompaniesForm />
          <BottomBar />
        </Stack>
      </Page>
    </>
  );
};
